export function valueIsEmpty(value) {
  return value == null || value === '';
}
export function valueIsNotEmpty(value) {
  return !valueIsEmpty(value);
}